module.exports = __webpack_public_path__ + "static/media/Tick_icon_purple.f9ae73a0.svg";